// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ComplianceResponseSchema = z.object({
  users: z.array(z.object({
    user_id: z.number().int(),
    name: z.coerce.string(),
    email: z.coerce.string(),
    weekly_capacity_hours: z.number().min(0),
    total_hours: z.number().min(0),
    ai_hours: z.number().min(0),
    automation_rate: z.number().min(0).max(1),
    last_seen_at: z.coerce.string().nullish(),
    memory_state: z.coerce.string(),
    last_hours_logged_at: z.coerce.string().nullish(),
    memory_active_days_in_window: z.number().int().min(0),
    logged_days_in_window: z.number().int().min(0),
  })).describe("Per-user compliance metrics"),
  period: z.object({
    from: z.coerce.string().describe("ISO8601 start date (inclusive)"),
    to: z.coerce.string().describe("ISO8601 end date (inclusive)"),
  }),
  memory_app_adoption_pct: z.number().min(0).max(100).describe("Workspace-level Memory app adoption: percentage of active users with any MemoryAppLog activity in the window. Rounded to 1 decimal place. 0.0 when there are no active users."),
});
